import { useEffect, useRef, useState } from "react";
import { ev } from "../../lib/everythingCopy";
import { submitDeleteAuth } from "../../lib/deleteAuth";

const VERIFY_DEBOUNCE_MS = 2000;

export function DeleteAuth({ authenticated, onAuthenticated }) {
  const [password, setPassword] = useState("");
  const [checking, setChecking] = useState(false);
  const timerRef = useRef(null);
  const lastVerifiedRef = useRef("");

  useEffect(() => () => clearTimeout(timerRef.current), []);

  if (authenticated) {
    return (
      <span className="text-[10px] font-medium uppercase tracking-wider text-emerald-600 dark:text-emerald-400 shrink-0">
        {ev.authActive}
      </span>
    );
  }

  function onChange(e) {
    const value = e.target.value;
    setPassword(value);
    clearTimeout(timerRef.current);
    if (!value.trim()) return;
    timerRef.current = setTimeout(() => verify(value), VERIFY_DEBOUNCE_MS);
  }

  async function verify(value) {
    if (checking || value === lastVerifiedRef.current) return;
    lastVerifiedRef.current = value;
    setChecking(true);
    try {
      const result = await submitDeleteAuth(value, onAuthenticated);
      if (result !== "ok") setPassword("");
    } finally {
      setChecking(false);
    }
  }

  return (
    <div className="relative shrink-0">
      <input
        type="password"
        value={password}
        onChange={onChange}
        placeholder={ev.authPlaceholder}
        autoComplete="off"
        disabled={checking}
        aria-label={ev.authPlaceholder}
        className="w-24 sm:w-28 bg-transparent border-0 border-b border-zinc-200/80 dark:border-zinc-700/80 px-1 py-1 text-xs text-zinc-700 dark:text-zinc-200 placeholder:text-zinc-300 dark:placeholder:text-zinc-600 placeholder:italic focus:outline-none focus:border-zinc-400 dark:focus:border-zinc-500 transition-colors disabled:opacity-60"
      />
      {checking && (
        <span className="absolute right-1 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full border border-zinc-300 dark:border-zinc-700 border-t-zinc-500 dark:border-t-zinc-400 animate-spin" />
      )}
    </div>
  );
}
